var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 61,
    viewBox: "0 0 191 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.972 57.6534C173.3 57.5985 173.297 58.9671 157.625 58.9122C141.953 58.8573 141.952 57.1381 126.28 57.0832C110.609 57.0283 110.606 57.6278 94.9341 57.5729C79.2622 57.518 79.2589 57.2239 63.5869 57.1577C47.9148 57.0915 47.9131 57.7588 32.2412 57.7039C16.5693 57.649 16.5658 57.3437 0.893814 57.2774C0.689839 57.2801 0.618495 57.5299 0.615666 57.2811C0.618217 30.5878 1.36007 30.5894 1.35335 3.89627C1.35979 3.64735 0.686584 3.1585 0.890559 3.15582C16.5625 3.21074 16.5621 3.99118 32.2341 4.0574C47.906 4.11231 47.9051 3.21878 63.5772 3.285C79.2491 3.33991 79.2533 2.89874 94.9252 2.95365C110.597 3.00856 110.595 2.82762 126.267 2.89384C141.939 2.94875 141.938 3.71788 157.62 3.77267C173.301 3.82746 173.297 3.48819 188.969 3.54311C189.173 3.54043 190.026 4.35494 190.029 4.60374C190.026 31.297 189.349 31.2946 189.347 57.9878C189.34 58.2254 189.176 57.6507 188.972 57.6534Z",
    fill: "#D4D4D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnMask);
export default __webpack_public_path__ + "static/media/btn-mask.2b9ff77fd23454ab2ab2045b5a323c60.svg";
export { ForwardRef as ReactComponent };